/**
 * @format
 */
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { PaperProvider } from 'react-native-paper';
//import 'react-native-gesture-handler';
import store from './store/store.ts';
import theme from './resources/Theme.ts';
import { TailwindProvider } from 'tailwind-rn';
import utilities from './tailwind.json';
import { Provider } from 'react-redux';
import { AppProvider } from './AppContext.tsx';
import { Platform } from 'react-native';
import RootNavigator from './screens/RootNavigation.tsx';
import { getPathFromState as getPathFromStateNative, getStateFromPath as getStateFromPathNative } from '@react-navigation/native';

const linking = {
    prefixes: [
        'https://storage.googleapis.com/qualitas-rnw-dev',
        //'https://storage.googleapis.com/cecy-front-dev',
        //'http://localhost:8080',
    ],
    config: {
        screens: {
            Conversaciones: 'chat',
            Horarios: 'horarios',
        },
    },

    // 1. Lee la URL y la limpia para la App
    getStateFromPath: (path, config) => {
        // En tu video se ve que path llega como "/index.html#/chat#/horarios"
        // Siempre tomamos lo que esté después del ÚLTIMO símbolo '#'
        const segments = path.split('#');
        let cleanPath = segments[segments.length - 1];

        // Quitamos el index.html por si se coló en el segmento
        cleanPath = cleanPath.replace('/index.html', '');

        // Nos aseguramos que empiece con una sola barra
        if (!cleanPath.startsWith('/')) {
            cleanPath = '/' + cleanPath;
        }

        return getStateFromPathNative(cleanPath, config);
    },

    // 2. Escribe la URL y evita duplicados
    getPathFromState: (state, config) => {
        const nativePath = getPathFromStateNative(state, config);

        // 🛡️ LIMPIEZA TOTAL: Antes de agregar el prefijo, 
        // borramos cualquier rastro de index.html o # que ya traiga la ruta
        const purePath = nativePath
            .replace(/\/index\.html/g, '')
            .replace(/#/g, '')
            .replace(/\/+/g, '/'); // Elimina barras dobles

        // Construimos la URL final con un formato único
        const finalPath = `/index.html#${purePath.startsWith('/') ? purePath : `/${purePath}`}`;

        return finalPath;
    },
};

const win = global as any;
if (Platform.OS === 'web' && win.window !== undefined) {
    const hash: string = win.window.location.hash;
    if (hash.split('#').length > 1) {
        const cleanHash = '#' + hash.split('#')[1];
        win.window.history.replaceState(null, '', win.window.location.pathname + cleanHash);
    }
}

function App(this: any): React.JSX.Element {
    return (
        <TailwindProvider utilities={utilities}>
            <Provider store={store}>
                {Platform.OS === 'web' ? (
                    <style type="text/css">{`
                    @font-face {
                    font-family: 'MaterialCommunityIcons';
                    src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
                    }
                `}</style>
                ) : null}
                <PaperProvider theme={theme}>
                    <NavigationContainer linking={linking}>
                        <AppProvider>
                            <RootNavigator />
                        </AppProvider>
                        {/* <FlashMessage position="bottom" /> */}
                    </NavigationContainer>
                </PaperProvider>
            </Provider>
        </TailwindProvider>
    );
}

export default App;
